import React, { FC } from "react";

import { FavouritesSettingsSlide } from "./FavouritesSettingsSlide";
import ReportsProvider from "../../../../reportng/ReportsProvider";

import { IFavouritesSettingsSlideProps } from "./FavouritesSettingsSlide.types";
export const FavouritesSettingsSlideProvider: FC<IFavouritesSettingsSlideProps> = (props) => {
  const { item } = props;

  return (
    <ReportsProvider reportId={item.mark.reportId} applySavedFavouriteByDefault>
      <FavouritesSettingsSlide {...props} />
    </ReportsProvider>
  );
};
